import request from "root/js/request";

export const getSocialBloggersBloggers = async ({
  source__in,
  item__in,
  subject_id__in = item__in,
  brand_id__in,
  product_id__in,
  limit = 100,
  offset = 0,
  search,
  ...rest
}) => {
  const response = await request({
    url: `parsers/social/bloggers/bloggers/`,
    method: "get",
    params: {
      source__in,
      item__in,
      subject_id__in,
      brand_id__in,
      product_id__in,
      limit,
      offset,
      search,
      ...rest,
    },
  });
  return response;
};
